import React, { useState } from "react";

import { useAuth } from "react-oidc-context";

import Sidebar from "./Sidebar";
import MainContent from "./MainContent";
import TableView from "./TableView";
import DataView from "./DataView";
import ChatInterface from "./ChatInterface";
import FileExplorer from "./FileExplorer";
import ReportsView from "./Reports/ReportsView";
import DashboardsView from "./Dashboards/DashboardsView";
import WelcomeView from "./WelcomeView";
import PendingAccessView from "./PendingAccessView";

import "../styles/MainApp.css";

import {
  getPermissions,
  canAccessView,
} from "../utils/permissions";


const MainApp = () => {
  const auth = useAuth();

  const [view, setView] = useState("welcome");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const userId = auth.user?.profile?.sub;

  const permissions = getPermissions(auth.user);

  /*
   * SEGURIDAD:
   * Nunca renderizamos directamente la vista solicitada.
   * Primero validamos que el usuario tenga el permiso correspondiente.
   */
  const safeView =
    permissions.hasAssignedRole &&
    canAccessView(view, permissions)
      ? view
      : "welcome";


  return (
    <div
      className={`main-app ${
        sidebarCollapsed ? "sidebar-collapsed" : ""
      }`}
    >
      <Sidebar
        setView={setView}
        activeView={safeView}
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
      />

      <main className="content-container">
        <div className="page-content">
          {!permissions.hasAssignedRole ? (
            <PendingAccessView />
          ) : (
            <>
              {safeView === "welcome" && (
                <WelcomeView setView={setView} />
              )}

              {safeView === "upload" && (
                <MainContent />
              )}

              {safeView === "viewFiles" && (
                <TableView userId={userId} />
              )}

              {safeView === "data" && (
                <DataView />
              )}

              {safeView === "chatInterface" && (
                <ChatInterface />
              )}

              {safeView === "FileExplorer" && (
                <FileExplorer userId={userId} />
              )}

              {safeView === "ReportsView" && (
                <ReportsView />
              )}

              {safeView === "DashboardsView" && (
                <DashboardsView />
              )}
            </>
          )}
        </div>
      </main>
    </div>
  );
};


export default MainApp;
